export const manifest = {
	appDir: "_app",
	assets: new Set([".DS_Store","favicon.png","fonts.css","gva-it.jpg","helvetica-neue/HelveticaNowDisplay-Black.eot","helvetica-neue/HelveticaNowDisplay-Black.ttf","helvetica-neue/HelveticaNowDisplay-Black.woff","helvetica-neue/HelveticaNowDisplay-Black.woff2","helvetica-neue/HelveticaNowDisplay-BlackIta.eot","helvetica-neue/HelveticaNowDisplay-BlackIta.ttf","helvetica-neue/HelveticaNowDisplay-BlackIta.woff","helvetica-neue/HelveticaNowDisplay-BlackIta.woff2","helvetica-neue/HelveticaNowDisplay-Bold.eot","helvetica-neue/HelveticaNowDisplay-Bold.ttf","helvetica-neue/HelveticaNowDisplay-Bold.woff","helvetica-neue/HelveticaNowDisplay-Bold.woff2","helvetica-neue/HelveticaNowDisplay-BoldIta.eot","helvetica-neue/HelveticaNowDisplay-BoldIta.ttf","helvetica-neue/HelveticaNowDisplay-BoldIta.woff","helvetica-neue/HelveticaNowDisplay-BoldIta.woff2","helvetica-neue/HelveticaNowDisplay-ExtBdIta.eot","helvetica-neue/HelveticaNowDisplay-ExtBdIta.ttf","helvetica-neue/HelveticaNowDisplay-ExtBdIta.woff","helvetica-neue/HelveticaNowDisplay-ExtBdIta.woff2","helvetica-neue/HelveticaNowDisplay-ExtBlk.eot","helvetica-neue/HelveticaNowDisplay-ExtBlk.ttf","helvetica-neue/HelveticaNowDisplay-ExtBlk.woff","helvetica-neue/HelveticaNowDisplay-ExtBlk.woff2","helvetica-neue/HelveticaNowDisplay-ExtBlkIta.eot","helvetica-neue/HelveticaNowDisplay-ExtBlkIta.ttf","helvetica-neue/HelveticaNowDisplay-ExtBlkIta.woff","helvetica-neue/HelveticaNowDisplay-ExtBlkIta.woff2","helvetica-neue/HelveticaNowDisplay-ExtLt.eot","helvetica-neue/HelveticaNowDisplay-ExtLt.ttf","helvetica-neue/HelveticaNowDisplay-ExtLt.woff","helvetica-neue/HelveticaNowDisplay-ExtLt.woff2","helvetica-neue/HelveticaNowDisplay-ExtLtIta.eot","helvetica-neue/HelveticaNowDisplay-ExtLtIta.ttf","helvetica-neue/HelveticaNowDisplay-ExtLtIta.woff","helvetica-neue/HelveticaNowDisplay-ExtLtIta.woff2","helvetica-neue/HelveticaNowDisplay-ExtraBold.eot","helvetica-neue/HelveticaNowDisplay-ExtraBold.ttf","helvetica-neue/HelveticaNowDisplay-ExtraBold.woff","helvetica-neue/HelveticaNowDisplay-ExtraBold.woff2","helvetica-neue/HelveticaNowDisplay-Hairline.eot","helvetica-neue/HelveticaNowDisplay-Hairline.ttf","helvetica-neue/HelveticaNowDisplay-Hairline.woff","helvetica-neue/HelveticaNowDisplay-Hairline.woff2","helvetica-neue/HelveticaNowDisplay-HairlineI.eot","helvetica-neue/HelveticaNowDisplay-HairlineI.ttf","helvetica-neue/HelveticaNowDisplay-HairlineI.woff","helvetica-neue/HelveticaNowDisplay-HairlineI.woff2","helvetica-neue/HelveticaNowDisplay-Light.eot","helvetica-neue/HelveticaNowDisplay-Light.ttf","helvetica-neue/HelveticaNowDisplay-Light.woff","helvetica-neue/HelveticaNowDisplay-Light.woff2","helvetica-neue/HelveticaNowDisplay-LightIta.eot","helvetica-neue/HelveticaNowDisplay-LightIta.ttf","helvetica-neue/HelveticaNowDisplay-LightIta.woff","helvetica-neue/HelveticaNowDisplay-LightIta.woff2","helvetica-neue/HelveticaNowDisplay-MedIta.eot","helvetica-neue/HelveticaNowDisplay-MedIta.ttf","helvetica-neue/HelveticaNowDisplay-MedIta.woff","helvetica-neue/HelveticaNowDisplay-MedIta.woff2","helvetica-neue/HelveticaNowDisplay-Medium.eot","helvetica-neue/HelveticaNowDisplay-Medium.ttf","helvetica-neue/HelveticaNowDisplay-Medium.woff","helvetica-neue/HelveticaNowDisplay-Medium.woff2","helvetica-neue/HelveticaNowDisplay-RegIta.eot","helvetica-neue/HelveticaNowDisplay-RegIta.ttf","helvetica-neue/HelveticaNowDisplay-RegIta.woff","helvetica-neue/HelveticaNowDisplay-RegIta.woff2","helvetica-neue/HelveticaNowDisplay-Regular.eot","helvetica-neue/HelveticaNowDisplay-Regular.ttf","helvetica-neue/HelveticaNowDisplay-Regular.woff","helvetica-neue/HelveticaNowDisplay-Regular.woff2","helvetica-neue/HelveticaNowDisplay-Thin.eot","helvetica-neue/HelveticaNowDisplay-Thin.ttf","helvetica-neue/HelveticaNowDisplay-Thin.woff","helvetica-neue/HelveticaNowDisplay-Thin.woff2","helvetica-neue/HelveticaNowDisplay-ThinIta.eot","helvetica-neue/HelveticaNowDisplay-ThinIta.ttf","helvetica-neue/HelveticaNowDisplay-ThinIta.woff","helvetica-neue/HelveticaNowDisplay-ThinIta.woff2","logos/3cx.svg","logos/hpe.svg","logos/sonicwall.svg","logos/sophos.svg","logos/veeam.svg","ordi-tutor.jpg","photo-equipe.png"]),
	mimeTypes: {".png":"image/png",".css":"text/css",".jpg":"image/jpeg",".eot":"application/vnd.ms-fontobject",".ttf":"font/ttf",".woff":"font/woff",".woff2":"font/woff2",".svg":"image/svg+xml"},
	_: {
		entry: {"file":"_app/immutable/start-d950f3b2.js","imports":["_app/immutable/start-d950f3b2.js","_app/immutable/chunks/index-d33e9054.js","_app/immutable/chunks/singletons-56d9a26f.js"],"stylesheets":[]},
		nodes: [
			() => import('.//nodes/0.js'),
			() => import('.//nodes/1.js'),
			() => import('.//nodes/2.js'),
			() => import('.//nodes/3.js'),
			() => import('.//nodes/4.js'),
			() => import('.//nodes/5.js'),
			() => import('.//nodes/6.js'),
			() => import('.//nodes/7.js'),
			() => import('.//nodes/8.js'),
			() => import('.//nodes/9.js')
		],
		routes: [
			{
					id: "",
					pattern: /^\/$/,
					names: [],
					types: [],
					page: {"layouts":[0],"errors":[1],"leaf":2},
					endpoint: null
				},
			{
					id: "a-propos",
					pattern: /^\/a-propos\/?$/,
					names: [],
					types: [],
					page: {"layouts":[0],"errors":[1],"leaf":3},
					endpoint: null
				},
			{
					id: "contact",
					pattern: /^\/contact\/?$/,
					names: [],
					types: [],
					page: {"layouts":[0],"errors":[1],"leaf":4},
					endpoint: null
				},
			{
					id: "maintenance-support-informatique",
					pattern: /^\/maintenance-support-informatique\/?$/,
					names: [],
					types: [],
					page: {"layouts":[0],"errors":[1],"leaf":5},
					endpoint: null
				},
			{
					id: "services",
					pattern: /^\/services\/?$/,
					names: [],
					types: [],
					page: {"layouts":[0],"errors":[1],"leaf":6},
					endpoint: null
				},
			{
					id: "solutions-hebergees",
					pattern: /^\/solutions-hebergees\/?$/,
					names: [],
					types: [],
					page: {"layouts":[0],"errors":[1],"leaf":8},
					endpoint: null
				},
			{
					id: "services/[slug]",
					pattern: /^\/services\/([^/]+?)\/?$/,
					names: ["slug"],
					types: [null],
					page: {"layouts":[0],"errors":[1],"leaf":7},
					endpoint: null
				},
			{
					id: "solutions-hebergees/[slug]",
					pattern: /^\/solutions-hebergees\/([^/]+?)\/?$/,
					names: ["slug"],
					types: [null],
					page: {"layouts":[0],"errors":[1],"leaf":9},
					endpoint: null
				},
			{
					id: "api/[...query]",
					pattern: /^\/api(?:\/(.*))?\/?$/,
					names: ["query"],
					types: [null],
					page: null,
					endpoint: () => import('.//entries/endpoints/api/_...query_/_server.js')
				}
		],
		matchers: async () => {
			
			return {  };
		}
	}
};